export const indonesiaOnlineTerms = (
  <>
    <h5>
      Before proceeding, please read and agree to the following terms &
      conditions for Online Participants:
    </h5>
    <ul>
      <li>
        Please be advised that all data submitted by participants cannot be modified after the payment deadline. Therefore, participants are required to carefully review their Letter of Acceptance (LoA) and registration information prior to submission to ensure that all details provided are accurate, complete, and correct.
      </li>
      <li>
        Participants who do not submit the required documents (Full Paper) by the specified deadline will not receive a document score and will only receive a score during the live judging session.
      </li>
      <li>
        Participants must use titles and full papers that are appropriate for the category they are participating in. (For participants participating in international events, English must be used for all requirements.)
      </li>
      <li>
        The committee's decision on this matter is final and cannot be contested.
      </li>
    </ul>
    <p className="text-align">
      Additionally, we inform you that each event will be registered for
      curation by SIM T Puspresnas.
    </p>
    <p className="text-align">
      However, the curation results are fully under the authority of Puspresnas
      and cannot be contested by any party. Therefore, we do not accept
      objections or complaints regarding the results determined by Puspresnas.
    </p>
  </>
);

export const indonesiaOfflineTerms = (
  <>
    <h5>
      Before proceeding, please read and agree to the following terms &
      conditions for Offline Participants:
    </h5>
    <ul>
      <li>
        Please be advised that all data submitted by participants cannot be modified after the payment deadline. Therefore, participants are required to carefully review their Letter of Acceptance (LoA) and registration information prior to submission to ensure that all details provided are accurate, complete, and correct.
      </li>
      <li>
        Participants who do not submit the required documents (Full Paper) by the specified deadline will not receive a document score and will only receive a score during the live judging session.
      </li>
      <li>
        Participants must use titles and full papers that are appropriate for the category they are participating in. (For participants participating in international events, English must be used for all requirements.)
      </li>
      <li>
        Participants are required to make an A0-sized poster and bring the product and poster to the judging session.
      </li>
      <li>
        Awards will be presented to participants in the order specified in the program schedule (participants are not permitted to request their award before their turn).
      </li>
      <li>
        Participants are required to attend all activities according to the schedule prepared by the organizing committee.
      </li>
      <li>
        For offline participants who are entitled to the Best Booth, Best Poster, Best Presentation, Best Project, cash prize, semi-grand award, and grand award but are unable to attend the award ceremony, the prizes in question will be forfeited.
      </li>
      <li>
        The committee's decision on this matter is final and cannot be contested.
      </li>
    </ul>
    <p className="text-align">
      Additionally, we inform you that each event will be registered for
      curation by SIM T Puspresnas.
    </p>
    <p className="text-align">
      However, the curation results are fully under the authority of Puspresnas
      and cannot be contested by any party. Therefore, we do not accept
      objections or complaints regarding the results determined by Puspresnas.
    </p>
  </>
);

export const internationalOnlineTerms = (
  <>
    <h3 className="text-2xl">Online Participants:</h3>
    <li>
      Please be advised that all data submitted by participants cannot be modified after the payment deadline. Therefore, participants are required to carefully review their Letter of Acceptance (LoA) and registration information prior to submission to ensure that all details provided are accurate, complete, and correct.
    </li>
    <li>
      Participants who do not submit the required documents (Full Paper) by the specified deadline will not receive a file score and will only receive a score during the live judging session.
    </li>
    <li>
      Participants must use titles and complete papers that correspond to the category they are participating in. (For participants attending international events, English must be used for all requirements).
    </li>
    <li>
      The committee's decision regarding this matter is final and cannot be contested.
    </li>
  </>
);

export const internationalOfflineTerms = (
  <>
    <h3 className="text-2xl">Offline Participants:</h3>
    <li>
      Please be advised that all data submitted by participants cannot be modified after the payment deadline. Therefore, participants are required to carefully review their Letter of Acceptance (LoA) and registration information prior to submission to ensure that all details provided are accurate, complete, and correct.
    </li>
    <li>
      Participants who do not submit the required documents (Full Paper) by the specified deadline will not receive a file score and will only receive a score during the live judging session.
    </li>
    <li>
      Participants must use titles and full papers that correspond to the category they are participating in. (For participants participating in international events, English must be used for all requirements.)
    </li>
    <li>
      Participants are required to create an A0-sized poster and bring the product and poster to the judging session.
    </li>
    <li>
      The awarding of awards to participants will be carried out in accordance with the order set out in the schedule of events (participants are not allowed to request awards before their turn).
    </li>
    <li>
      Participants are required to follow the entire series of activities in accordance with the schedule prepared by the organising committee.
    </li>
    <li>
      For offline participants who are entitled to the Best booth, Best Poster, Best Presentation, Best Project, cash, semi grand award, and grand award prizes but cannot attend the prize distribution ceremony, the prizes concerned will be declared forfeited.
    </li>
    <li>
      The committee's decision regarding this matter is final and cannot be contested.
    </li>
  </>
);
